import { Component } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';


@Component({
    selector: 'if-elseif-else-statment-snippet',
    template: '',
    standalone: false
})
export class IfElseIfStatementpSnippet implements CodeSnippet{

    text : string = $localize`:@@script-editor.snippet.if-else-if:if else-if`;

    static category = 'common'

    data: any;

    part = true;

    insert(): string | Promise<string> {
        return `
    if �<boolean_expression>� then
        -- statement(s) will execute if the boolean_expression is true
    elseif <other_boolean_expression> then
        -- statement(s) will execute if the other_boolean_expression is true
    else
        -- statement(s) will execute if prior boolean expressions are false
    end
`
    }
}